import { AfterSales, AfterSalesDetails } from 'pages/afterSales'
import { Home, PurchaseConfirmation, Receipt, RepurchaseIncentive } from 'pages/landingPage'
import { Game, MyTickets, Start } from 'pages/scratchcard'
import { Faq, RegistrationForm } from 'pages/shared'
import { RedeemValue } from 'pages/afterSales/AfterSales/redemption/RedeemValue/RedeemValue'
import { RedemptionReceipt } from 'pages/afterSales/AfterSales/redemption/RedemptionReceipt/RedemptionReceipt'
import { Repurchase } from 'pages/afterSales/AfterSales/redemption/Repurchase/Repurchase'

import { TypesRoutes as Routes } from './types'

export const mixedRoutes = [
  // SCRATCHCARD
  { route: Routes.START, component: Start },
  { route: Routes.GAME, component: Game },
  { route: Routes.MY_TICKETS, component: MyTickets },

  // AFTER SALES
  { route: Routes.AFTER_SALES, component: AfterSales },
  { route: Routes.AFTER_SALES_DETAILS, component: AfterSalesDetails },

  // LANDING PAGE
  { route: Routes.LANDING_PAGE_HOME, component: Home },
  { route: Routes.LANDING_PAGE_CONFIRMATION, component: PurchaseConfirmation },
  { route: Routes.LANDING_PAGE_RECEIPT, component: Receipt },
  { route: Routes.REPURCHASE_INCENTIVE, component: RepurchaseIncentive },

  // SHARED
  { route: Routes.FAQ, component: Faq },
  { route: Routes.REGISTRATION_FORM, component: RegistrationForm },

  // REDEMPTION
  { route: Routes.REDEEM_VALUE, component: RedeemValue },
  { route: Routes.REPURCHASE, component: Repurchase },
  { route: Routes.REDEMPTION_RECEIPT, component: RedemptionReceipt },
]

export * from './types'
